import { jwtDecode } from "jwt-decode";

// Store only the token
export const updateLocalStorageData = (data) => {
  localStorage.setItem("token", data.token);
  console.log(data.token);
  window.dispatchEvent(new Event("localStorageDataUpdate"));
};

// Decode token and return the employee/user data
export const getEmployeeData = () => {
  try {
    const token = localStorage.getItem("token");
    if (!token) return null;

    const decoded = jwtDecode(token);
    return decoded || null;
  } catch (error) {
    console.error("Error decoding token:", error);
    return null;
  }
};

// Get employee ID
export const getEmployeeId = () => {
  const employeeData = getEmployeeData();
  return employeeData?.employeeId || employeeData?.userId || null;
};

// Get company/user timezone from JWT token (Windows ID e.g. "Pacific Standard Time")
export const getUserTimeZone = () => getEmployeeData()?.timeZone || null;